// extracted by mini-css-extract-plugin
export default {"root":"MaterialPill_root__w0BY2","typeIconContainer":"MaterialPill_typeIconContainer__Qh5BK","name":"MaterialPill_name__hkBTa","homeworkIcon":"MaterialPill_homeworkIcon__4SNqk"};